/** 首页 FAQ（与正文配套） */
export default [
  {
    question: 'Is OG WhatsApp safe to use?',
    answer:
      'It can be <strong>safer when you follow good habits</strong>: download only from sources you trust, keep backups, and update when your publisher ships fixes. Mods are not official apps—there is always some residual risk, so never treat any APK as “zero risk.”',
  },
  {
    question: 'Will I get banned for using OG WhatsApp?',
    answer:
      'There is <strong>no guarantee</strong> either way. Many builds advertise anti-ban measures as <strong>risk reduction</strong>, not a promise. Avoid spam-like behavior, don’t bounce between suspicious forks, and read the latest notes before each update.',
  },
  {
    question: 'Can I use OG WhatsApp and the official WhatsApp on the same phone?',
    answer:
      'Often yes—<strong>dual WhatsApp</strong> setups typically need a <strong>second phone number</strong> for the modded client. Exact steps depend on your build; follow the setup wizard after install.',
  },
  {
    question: 'How do I transfer my chat history from official WhatsApp to OG WhatsApp?',
    answer:
      'Take a <strong>fresh backup</strong> in official WhatsApp first. During OG setup, choose <strong>Restore</strong> if your build detects a compatible backup. If restore fails, stop and read your fork’s migration guide—forcing it can lose data.',
  },
  {
    question: 'Is OG WhatsApp available for iOS?',
    answer:
      '<strong>No</strong>—the ecosystem discussed here is Android APK sideloading. Be very cautious of anything claiming “OG WhatsApp for iPhone” outside the App Store.',
  },
  {
    question: 'Do I need to root my Android phone to use OG WhatsApp?',
    answer:
      '<strong>No</strong>—you should not need root for typical installs on Android 5.0+; you only need a controlled “unknown sources” path for the browser you use to fetch the APK.',
  },
  {
    question: 'What if I have issues with OG WhatsApp?',
    answer:
      'Start with the FAQ on this page, then re-check file size/version and permissions. For site issues (broken links), use our <a href="/about/">About</a> contact path— we can’t debug every device remotely.',
  },
];
